import styled from 'styled-components';

import {
  getDegreeOfRotation,
  getOffsetClipPath,
  getWidthPrizeInPercent,
} from '@/helpers/wheel';
import { device, hexToRGB } from '@/styles/helpers';

export const ScWheelPrize = styled.div<{ total: number; index: number }>`
  height: 50%;
  position: absolute;
  width: ${({ total }) => `${getWidthPrizeInPercent(total)}%`};
  margin-left: ${({ total }) => `${getWidthPrizeInPercent(total) / -2}%`};
  left: 50.1%;
  top: 0;
  transform-origin: bottom center;
  transform: ${({ total, index }) =>
    `rotate(${getDegreeOfRotation(total, index)}deg)`};
`;

export const ScWheelPrizeBg = styled.div<{
  index: number;
  total: number;
  isHighlighted: boolean;
}>`
  position: absolute;
  inset: 0;
  background: ${({ theme, isHighlighted }) =>
    isHighlighted ? hexToRGB(theme.yellowSeaColor, 0.4) : theme.green4Color};
  clip-path: ${({ total }) =>
    `polygon(50% 98%, ${5 - getOffsetClipPath(total)}% 0, ${
      100 + getOffsetClipPath(total)
    }% 0)`};
`;

export const ScWheelPrizeName = styled.div<{ isLocked: boolean }>`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(270deg);
  z-index: 4;
  font-size: 32px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.96px;
  white-space: normal;
  text-align: center;
  width: 70%;
  color: ${({ theme, isLocked }) =>
    isLocked ? hexToRGB(theme.whiteColor, 0.2) : theme.whiteColor};
  text-transform: capitalize;

  @media (${device.mobile}) {
    font-size: 20px;
    line-height: 20px;
  }
`;
